import { SET_USER_INTERACT_ON, SET_USER_INTERACT_OFF } from "../reduxConstants";

export const setUserInteractOn = () => ({
  type: SET_USER_INTERACT_ON,
});

export const setUserInteractOff = () => ({
  type: SET_USER_INTERACT_OFF,
});
